import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { adminDashboardDetailsApi, cityByCountryApi, countryListApi, getUserDetailsByIdApi } from "../../../utils/ApiEndpointFunctions";
import Spinwheel from "../../common/Spinwheel";
import TopPerformerCard from "../../common/Cards/TopPerformerCard";
import { useAdminContext } from "../../../context/adminContext";
import { useFormik } from 'formik';
import ReactSelect from 'react-select';
import InfoPanel from "../dashboard/components/InfoPanel";
import DashboardCommonCard from "../dashboard/components/DashboardComonCard";

export default function ViewReport({ userId, type }) {
  const { limit, adminDetail } = useAdminContext();
  const [userProfile, setUserProfile] = useState({})
  const [loader, setLoader] = useState(true)
  const [details, setDetails] = useState({})


  const [countryOptions, setCountryOptions] = useState([])
  const [cityOptions, setCityOptions] = useState([])

  const filterCites = async (countryId) => {
    try {
      const res = await cityByCountryApi("", countryId)
      if (res.status === 200) {
        let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
        setCityOptions(cityOption);
      }

    } catch (error) {
      console.log(error)
    }
  };

  const filterCountry = async (inputValue) => {
    try {
      const res = await countryListApi(inputValue)
      if (res.status === 200) {
        let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
        setCountryOptions(cityOption);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const handleCityChange = (city) => {
    searchFormik.setFieldValue('cityId', city)
  }

  const handleCountryChange = (country) => {
    console.log(country, 'this is count')
    setCityOptions([])
    searchFormik.setFieldValue('countryId', country);
    searchFormik.setFieldValue('cityId', null);
    filterCites(country.value)
  }

  const searchFormik = useFormik({
    initialValues: {
      countryId: adminDetail?.role !== "superAdmin" && adminDetail?.countryId ? { label: adminDetail?.countryName, value: adminDetail?.countryId } : null,
      cityId: null,
    },
  })

  useEffect(() => {
    if (adminDetail?.countryId) {
      filterCites(adminDetail.countryId);
    }

    if (adminDetail?.role === "superAdmin") {
      filterCountry();
    }
  }, [adminDetail]);


  const getDashboardDetails = async (countryName = "", cityName = "") => {
    try {
      setLoader(true);
      const res = await adminDashboardDetailsApi(countryName, cityName);
      setDetails(res?.data?.data);
      setLoader(false);
    } catch (error) {
      console.log(error);

      toast.error(error.message || "Something went wrong");
      setLoader(false);
    }
  }

  useEffect(() => {
    const { countryId, cityId } = searchFormik?.values
    getDashboardDetails(countryId?.label, cityId?.label);
  }, [searchFormik?.values])

  const toFixedNumber = (num) => {
    if (num) {
      return Number(num).toFixed(2)
    }
    return 0.00
  }

  console.log("search", loader);


  return (
    <>
      <div className="main-content">

        <div className="container-fluid">
          {
            loader ? <Spinwheel /> :
              <>
                <div className="card">
                  <div className="d-flex justify-content-between flex-wrap align-items-center mt-3 mt-lg-0 py-4">
                    <div className="d-flex gap-2 justify-content-end align-items-end w-100 px-5" style={{ display: "-webkit-inline-box" }}>
                      <div className="d-flex gap-2">
                        <div className="d-flex align-items-center gap-2">
                          <label htmlFor="city" className="form-label">Country</label>
                          <ReactSelect className='reactSelectMinWidth' isDisabled={adminDetail.role !== "superAdmin"} options={countryOptions} value={searchFormik?.values?.countryId} onChange={handleCountryChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Countries Available'} />
                          {searchFormik?.touched?.countryId && searchFormik?.errors?.countryId ? (<div className='req-error'>{searchFormik?.errors?.countryId}</div>) : null}
                        </div>

                        <div className="d-flex align-items-center gap-2">
                          <label htmlFor="city" className="form-label">City</label>
                          <ReactSelect className='reactSelectMinWidth' options={cityOptions} isDisabled={!searchFormik?.values?.countryId} value={searchFormik?.values?.cityId} onChange={handleCityChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Cities Available'} />
                          {searchFormik?.touched?.cityId && searchFormik?.errors?.cityId ? (<div className='req-error'>{searchFormik?.errors?.cityId}</div>) : null}
                        </div>

                        <div className='d-flex align-items-center gap-2'>
                          <button
                            className="btn btn-primary"
                            onClick={() => { searchFormik.resetForm(); }}
                            disabled={!searchFormik?.values?.countryId}
                          >
                            Reset filter
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>


                  {/* first row */}

                  <div className="custom-row p-3">
                    {/* Rides (Trips) Section */}
                    <InfoPanel title="Rides(trips)" variant="primary" className="col-12">
                      <div className="row">
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"Today"} value={details?.rideDetails?.[0]?.rideBookingThisDay || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"This Week"} value={details?.rideDetails?.[0]?.rideBookingThisWeek || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"This Month"} value={details?.rideDetails?.[0]?.rideBookingThisMonth || 0} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"Total Rides Requested"} value={details?.rideDetails?.[0]?.rideBookingTotal || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"In-Progress"} value={details?.rideDetails?.[0]?.inProgressRides || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Completed"} value={details?.rideDetails?.[0]?.completedRides || 0} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"Cancelled"} value={details?.rideDetails?.[0]?.cancelledRides || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Cancelled"} isValueBold={false} value={`${details?.rideDetails?.[0]?.cancelledRides || 0} (Riders: ${details?.rideDetails?.[0]?.userCancelledRide || 0} | Drivers: ${details?.rideDetails?.[0]?.driverCancelledRide || 0})`} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Expired Requests"} value={details?.rideDetails?.[0]?.expired || 0} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                      </div>
                    </InfoPanel>
                  </div>

                  {/* 2nd row */}
                  <div className="custom-row p-3">
                    <InfoPanel title={"Total Payment"} variant="primary" className={"w-100"}>

                      <div className="custom-row-flex" style={{ gap: "6px" }}>
                        <InfoPanel title="Ride" variant="light" className="col-12 col-md-6">
                          <div className="row">
                            <div className="col-4 col">
                              <div className="col-12">
                                <DashboardCommonCard title={"Today"} value={toFixedNumber(details?.rideDetails?.[0]?.rideTodayPayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"This Week"} value={toFixedNumber(details?.rideDetails?.[0]?.rideWeekPayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"This Month"} value={toFixedNumber(details?.rideDetails?.[0]?.rideMonthPayment)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Total"} value={toFixedNumber(details?.rideDetails?.[0]?.rideTotalPayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Cash"} value={toFixedNumber(details?.rideDetails?.[0]?.rideTotalCashPayment)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Mobile"} value={toFixedNumber(details?.rideDetails?.[0]?.rideTotalMobilePayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Wallet"} value={toFixedNumber(details?.rideDetails?.[0]?.rideTotalWalletPayment)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                          </div>
                        </InfoPanel>
                        <InfoPanel title="Food" variant="light" className="col-12 col-md-6">
                          <div className="row">
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Today"} value={toFixedNumber(details?.rideDetails?.[0]?.foodTodayPayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"This Week"} value={toFixedNumber(details?.rideDetails?.[0]?.foodWeekPayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"This Month"} value={toFixedNumber(details?.rideDetails?.[0]?.foodMonthPayment)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Total"} value={toFixedNumber(details?.rideDetails?.[0]?.foodTotalPayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Cash"} value={toFixedNumber(details?.rideDetails?.[0]?.foodTotalCashPayment)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Mobile"} value={toFixedNumber(details?.rideDetails?.[0]?.foodTotalMobilePayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Wallet"} value={toFixedNumber(details?.rideDetails?.[0]?.foodTotalWalletPayment)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                          </div>
                        </InfoPanel>
                        <InfoPanel title="Packages" variant="light" className="col-12 col-md-6">
                          <div className="row">
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Today"} value={toFixedNumber(details?.rideDetails?.[0]?.packageTodayPayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"This Week"} value={toFixedNumber(details?.rideDetails?.[0]?.packageWeekPayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"This Month"} value={toFixedNumber(details?.rideDetails?.[0]?.packageMonthPayment)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Total"} value={toFixedNumber(details?.rideDetails?.[0]?.packageTotalPayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Cash"} value={toFixedNumber(details?.rideDetails?.[0]?.packageTotalCashPayment)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              <div className="col-12">
                                <DashboardCommonCard title={"Mobile"} value={toFixedNumber(details?.rideDetails?.[0]?.packageTotalMobilePayment)} icon={<i class="bi bi-activity"></i>} />
                                <DashboardCommonCard title={"Wallet"} value={toFixedNumber(details?.rideDetails?.[0]?.packageTotalMobilePayment)} icon={<i class="bi bi-activity"></i>} />
                              </div>
                            </div>
                          </div>
                        </InfoPanel>
                      </div>

                    </InfoPanel>
                  </div>



                  {/* 3rd row */}


                  <div className="custom-row p-3">
                    <InfoPanel title="Drivers" variant="primary" className="col-12">
                      <div className="row">
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"Total Drivers"} value={details?.driverDetails?.[0]?.totalDriver || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Verified"} value={details?.driverDetails?.[0]?.approvedDriver || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Unverified"} value={details?.driverDetails?.[0]?.rejectedDriver || 0} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"Online"} value={details?.driverDetails?.[0]?.OnlineDriver || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"Offline"} value={`${details?.driverDetails?.[0]?.OfflineDriver || 0}`} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="col-12">
                            <DashboardCommonCard title={"OnSubscription"} value={details?.driverDetails?.[0]?.OnSubscriptionDriver || 0} icon={<i class="bi bi-activity"></i>} />
                            <DashboardCommonCard title={"OnCommission"} value={details?.driverDetails?.[0]?.OnCommissionDriver || 0} icon={<i class="bi bi-activity"></i>} />
                          </div>
                        </div>
                      </div>
                    </InfoPanel>
                  </div>

                  {/* 4th row */}
                  <div className="custom-row p-3">
                    <InfoPanel title={"Top Performing Drivers"} variant="primary" className={"w-100"}>
                      <div className="custom-row-flex" style={{ gap: "6px", flexWrap: 'nowrap' }}>

                        <InfoPanel title="Daily" variant="light" className="col-12 col-md-4">
                          <div className="row">
                            <div className="col-12">
                              {details?.topPerformarDriver?.filter(ele => ele?.PerformancePeriod?.toLowerCase() == "daily")?.sort((a, b) => Number(a?.rank) - Number(b?.rank))?.map(ele => <>
                                <TopPerformerCard title={ele?.driverName} firstValue={`Trips: ${ele?.totalTrips}`} secondValue={`Amount: ${toFixedNumber(ele?.totalEarnings)}`} icon={ele?.rank} />
                              </>)}
                            </div>

                          </div>
                        </InfoPanel>
                        <InfoPanel title="Weekly" variant="light" className="col-12 col-md-4">
                          <div className="row">

                            <div className="col-12">

                              {details?.topPerformarDriver?.filter(ele => ele?.PerformancePeriod?.toLowerCase() == "weekly")?.sort((a, b) => Number(a?.rank) - Number(b?.rank))?.map(ele => <>
                                <TopPerformerCard title={ele?.driverName} firstValue={`Trips: ${ele?.totalTrips}`} secondValue={`Amount: ${toFixedNumber(ele?.totalEarnings)}`} icon={ele?.rank} />
                              </>)}
                            </div>

                          </div>
                        </InfoPanel>
                        <InfoPanel title="Monthly" variant="light" className="col-12 col-md-4">
                          <div className="row">

                            <div className="col-12">
                              {details?.topPerformarDriver?.filter(ele => ele?.PerformancePeriod?.toLowerCase() == "monthly")?.sort((a, b) => Number(a?.rank) - Number(b?.rank))?.map(ele => <>
                                <TopPerformerCard title={ele?.driverName} firstValue={`Trips: ${ele?.totalTrips}`} secondValue={`Amount: ${toFixedNumber(ele?.totalEarnings)}`} icon={ele?.rank} />
                              </>)}
                            </div>

                          </div>
                        </InfoPanel>
                      </div>
                    </InfoPanel>
                  </div>


                  {/* 5th row */}
                  <div className="custom-row p-3">
                    <InfoPanel title={"Rewards/Referrals"} variant="primary" className={"w-100 g-1"}>

                      <div className="custom-row-flex" style={{ flexWrap: 'nowrap' }}>
                        <InfoPanel title="User Rewards" variant="light" className="col-12 col-md-4">
                          <div className="row">

                            <div className="col-12">
                              <DashboardCommonCard title={"Today"} value={toFixedNumber(details?.userRewardAndReferral[0]?.dailyrewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Weekly"} value={toFixedNumber(details?.userRewardAndReferral[0]?.weekRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Monthly"} value={toFixedNumber(details?.userRewardAndReferral[0]?.montlyRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Total"} value={toFixedNumber(details?.userRewardAndReferral[0]?.totalRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Expired"} value={toFixedNumber(details?.userRewardAndReferral[0]?.expiredRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                            </div>

                          </div>
                        </InfoPanel>
                        <InfoPanel title="User Referrals" variant="light" className="col-12 col-md-4">
                          <div className="row">
                            <div className="col-12">
                              <DashboardCommonCard title={"Today"} value={toFixedNumber(details?.userRewardAndReferral[0]?.dailyReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Weekly"} value={toFixedNumber(details?.userRewardAndReferral[0]?.weekReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Monthly"} value={toFixedNumber(details?.userRewardAndReferral[0]?.montlyReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Total"} value={toFixedNumber(details?.userRewardAndReferral[0]?.totalReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Expired"} value={toFixedNumber(details?.userRewardAndReferral[0]?.expiredReferralAmt)} icon={<i class="bi bi-activity"></i>} />

                            </div>
                          </div>
                        </InfoPanel>
                        <InfoPanel title="Partners Rewards" variant="light" className="col-12 col-md-4">
                          <div className="row">

                            <div className="col-12">
                              <DashboardCommonCard title={"Today"} value={toFixedNumber(details?.partnerRewardAndReferral[0]?.dailyrewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Weekly"} value={toFixedNumber(details?.partnerRewardAndReferral[0]?.weekRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Monthly"} value={toFixedNumber(details?.partnerRewardAndReferral[0]?.montlyRewardAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Total"} value={toFixedNumber(details?.partnerRewardAndReferral[0]?.totalrewardAmt)} icon={<i class="bi bi-activity"></i>} />

                            </div>
                          </div>
                        </InfoPanel>
                        <InfoPanel title="Partners Referrals" variant="light" className="col-12 col-md-4">
                          <div className="row">

                            <div className="col-12">
                              <DashboardCommonCard title={"Today"} value={toFixedNumber(details?.partnerRewardAndReferral[0]?.dailyReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Weekly"} value={toFixedNumber(details?.partnerRewardAndReferral[0]?.weekReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Monthly"} value={toFixedNumber(details?.partnerRewardAndReferral[0]?.montlyReferralAmt)} icon={<i class="bi bi-activity"></i>} />
                              <DashboardCommonCard title={"Total"} value={toFixedNumber(details?.partnerRewardAndReferral[0]?.totalReferralAmt)} icon={<i class="bi bi-activity"></i>} />

                            </div>
                          </div>
                        </InfoPanel>
                      </div>
                    </InfoPanel>
                  </div>
                </div>


              </>
          }
        </div >
      </div >

    </>
  );
}
